const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: 'e1fbb84ee9572cfd592832ce3e562f25',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;